// src/reports/RelatorioPDF.jsx
import React from "react";
import "./relatorioPDF.css";

export const RelatorioPDF = ({ restaurante, resumo, pedidos, desempenho, itens, delivery }) => {
    const formatDateTime = (isoString) => {
        if (!isoString || isoString === "--") return "--";

        const date = new Date(isoString);
        if (isNaN(date.getTime())) return "--";

        const pad = (n) => n.toString().padStart(2, "0");

        return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    };

    return (
        <div id="relatorio-pdf" className="pdf-container">

            {/* LOGO E TÍTULO */}
            <header className="pdf-header">
                <img src="/assets/logo-mesaclick.png" className="pdf-logo" alt="MesaClick" />
                <div>
                    <h1 className="pdf-header-title">Relatório do Restaurante</h1>
                    <p className="pdf-header-sub">{restaurante?.nome}</p>
                    <span className="pdf-header-sub">{new Date().toLocaleString("pt-BR")}</span>
                </div>
            </header>

            {/* CARDS RESUMO */}
            <section className="pdf-section">
                <h2 className="pdf-section-title">Resumo geral</h2>

                <div className="pdf-cards-container">
                    <div className="pdf-card">
                        <h3>Total de pedidos</h3>
                        <p>{resumo?.totalPedidos || 0}</p>
                    </div>

                    <div className="pdf-card">
                        <h3>Faturamento total</h3>
                        <p>R$ {resumo?.faturamentoTotal?.toFixed?.(2) || "0,00"}</p>
                    </div>

                    <div className="pdf-card">
                        <h3>Ticket médio</h3>
                        <p>R$ {resumo?.ticketMedio?.toFixed?.(2) || "0,00"}</p>
                    </div>
                </div>
            </section>

            {/* ITENS MAIS VENDIDOS */}
            <section className="pdf-section">
                <h2 className="pdf-section-title">Itens mais vendidos</h2>

                <table className="pdf-table">
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th>Qtd.</th>
                            <th>Faturamento</th>
                        </tr>
                    </thead>
                    <tbody>
                        {itens?.map((i, idx) => (
                            <tr key={idx}>
                                <td>{i.nome}</td>
                                <td>{i.quantidade}</td>
                                <td>R$ {i?.faturamento?.toFixed(2) || "0,00"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </section>

            {/* DESEMPENHO POR MESA */}
            <section className="pdf-section">
                <h2 className="pdf-section-title">Desempenho por mesa (Salão)</h2>

                <table className="pdf-table">
                    <thead>
                        <tr>
                            <th>Mesa</th>
                            <th>Pedidos</th>
                            <th>Total (R$)</th>
                            <th>Média</th>
                        </tr>
                    </thead>
                    <tbody>
                        {desempenho?.map((d, idx) => (
                            <tr key={idx}>
                                <td>{d.mesa || d.mesa_nome}</td>
                                <td>{d.qtd_pedidos}</td>
                                <td>R$ {d?.valor_total?.toFixed(2) || "0,00"}</td>
                                <td>R$ {d?.media_por_pedido?.toFixed(2) || "0,00"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </section>

            {/* DESEMPENHO DELIVERY */}
            <section className="pdf-section">
                <h2 className="pdf-section-title">Desempenho Delivery</h2>

                <table className="pdf-table">
                    <thead>
                        <tr>
                            <th>Mesa</th>
                            <th>Pedidos</th>
                            <th>Total (R$)</th>
                            <th>Média</th>
                        </tr>
                    </thead>
                    <tbody>
                        {delivery?.map((d, idx) => (
                            <tr key={idx}>
                                <td>{d.mesa || d.mesa_nome}</td>
                                <td>{d.qtd_pedidos}</td>
                                <td>R$ {d?.valor_total?.toFixed(2) || "0,00"}</td>
                                <td>R$ {d?.media_por_pedido?.toFixed(2) || "0,00"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </section>

            {/* LISTA DE PEDIDOS */}
            <section className="pdf-section">
                <h2 className="pdf-section-title">Pedidos no período</h2>

                <table className="pdf-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Mesa</th>
                            <th>Itens</th>
                            <th>Total</th>
                            <th>Status</th>
                            <th>Abertura</th>
                            <th>Fechamento</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pedidos?.map((p, idx) => (
                            <tr key={idx}>
                                <td>{p.numero || p.id}</td>
                                <td>{p.mesa || p.mesa_nome}</td>
                                <td>{p.items}</td>
                                <td>R$ {p?.valor_total?.toFixed(2) || "0,00"}</td>
                                <td>{p.status}</td>
                                <td>{p.aberto_em ? formatDateTime(p.aberto_em) : "--"}</td>
                                <td>{p.fechado_em ? formatDateTime(p.fechado_em) : "--"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </section>

        </div>
    );
};
